import { useApp } from '@backstage/core-plugin-api';
import MuiBrokenImageIcon from '@material-ui/icons/BrokenImage';
import React__default from 'react';

function AppIcon(props) {
  const { id: key, Fallback = MuiBrokenImageIcon, ...rest } = props;
  const app = useApp();
  const Icon = app.getSystemIcon(key) ?? Fallback;
  return /* @__PURE__ */ React__default.createElement(Icon, { ...rest });
}
function BrokenImageIcon(props) {
  return /* @__PURE__ */ React__default.createElement(AppIcon, { id: "brokenImage", ...props });
}
function CatalogIcon(props) {
  return /* @__PURE__ */ React__default.createElement(AppIcon, { id: "catalog", ...props });
}
function ChatIcon(props) {
  return /* @__PURE__ */ React__default.createElement(AppIcon, { id: "chat", ...props });
}
function DashboardIcon(props) {
  return /* @__PURE__ */ React__default.createElement(AppIcon, { id: "dashboard", ...props });
}
function DocsIcon(props) {
  return /* @__PURE__ */ React__default.createElement(AppIcon, { id: "docs", ...props });
}
function EmailIcon(props) {
  return /* @__PURE__ */ React__default.createElement(AppIcon, { id: "email", ...props });
}
function GitHubIcon(props) {
  return /* @__PURE__ */ React__default.createElement(AppIcon, { id: "github", ...props });
}
function GroupIcon(props) {
  return /* @__PURE__ */ React__default.createElement(AppIcon, { id: "group", ...props });
}
function HelpIcon(props) {
  return /* @__PURE__ */ React__default.createElement(AppIcon, { id: "help", ...props });
}
function UserIcon(props) {
  return /* @__PURE__ */ React__default.createElement(AppIcon, { id: "user", ...props });
}
function WarningIcon(props) {
  return /* @__PURE__ */ React__default.createElement(AppIcon, { id: "warning", ...props });
}

export { AppIcon, BrokenImageIcon, CatalogIcon, ChatIcon, DashboardIcon, DocsIcon, EmailIcon, GitHubIcon, GroupIcon, HelpIcon, UserIcon, WarningIcon };
//# sourceMappingURL=icons.esm.js.map
